import React, { Children, cloneElement, useCallback, useState } from 'react';

// BOOTSTRAP COMPONENTS
import { Col, Row } from 'react-bootstrap';

// CORE COMPONENTS
import Form from 'core/form/Form';
import Button from 'core/tools/Button';

// PARTS
import Card from 'parts/card/Card';
import Main from 'parts/main/Main';
import Module from 'parts/module/Module';

// LOCAL COMPONENTS
import Output from './Output';

// STYLES
import styles from './formWrapper.module.scss';

// MAIN COMPONENT
const FormWrapper = ({
  children,
  inline,
  vertical,
  fullWidth,
  plaintext,
  initialValues
}) => {

  // STATE
  const [ disabled, disable ] = useState(false)
  const [ cleared, clear ] = useState(false)

  // CALLBACKS
  const disableToggle = useCallback(
    () => {
      disable(!disabled);
    },
    [disabled, disable]
  )
  const clearToggle = useCallback(
    () => {
      clear(!cleared);
    },
    [cleared, clear]
  )

  // RENDER
  return (
    <Main className={styles.main}>
      <Form
        initialValues={cleared ? undefined : initialValues}
      >
        {!!inline &&
          <Form.Body.Inline size="sm">
            {inline}
          </Form.Body.Inline>
        }
        <Card>
          <Module>
            <Form.Body
              disabled={disabled}
              vertical={vertical}
              fullWidth={fullWidth}
              plaintext={plaintext}
            >
              {Children.map(children, (child, i) => child ? cloneElement(child, {
                input: Object.assign({
                  append: <Output name={child.props.name} plaintext={plaintext} />,
                }, child.props.input),
                key: i
              }) : null)}
            </Form.Body>
          </Module>
        </Card>
        <Row>
          <Col>
            <Button
              label={disabled ? 'Enable Inputs' : 'Disable Inputs'}
              onClick={disableToggle}
              outline
              fullWidth
            />
          </Col>
          <Col>
            <Button
              label={cleared ? 'Initialize Form' : 'Clear Form'}
              onClick={clearToggle}
              outline
              fullWidth
            />
          </Col>
          <Col>
            <Button
              type="submit"
              label="Submit Form"
              fullWidth
            />
          </Col>
        </Row>
      </Form>
    </Main>
  )
}

// EXPORT
export default FormWrapper;
